import { faPause, faPlay } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "../../Icon/Icon";
import { TileButton, TileButtonProps } from "./TileButton";

interface TilePlayButtonProps extends Omit<TileButtonProps, "aria-label"> {
  isPlaying: boolean;
  onAction: (event: React.MouseEvent, action: "TOGGLE_PLAY") => void;
  "aria-label"?: string;
}

export const classes = {
  container: "TilePlayButton-root",
};

export const TilePlayButton = (props: TilePlayButtonProps) => {
  const { isPlaying, onAction, ...rest } = props;

  const handleAction = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAction(e, "TOGGLE_PLAY");
  };

  return (
    <TileButton
      aria-label={isPlaying ? "Pause" : "Play"}
      variant="primary"
      className={classes.container}
      onClick={handleAction}
      {...rest}
    >
      <Icon size="medium" icon={isPlaying ? faPause : faPlay} />
    </TileButton>
  );
};
